import { createFileRoute } from "@tanstack/react-router";
import type { SortField, SortDirection } from "../hooks/useOrgPois";
import type { OverrideFilter, SponsorTierFilter, CompletenessFilterValue } from "../components/admin/pois/POIFilters";

const VALID_COMPLETENESS_FILTERS: CompletenessFilterValue[] = [
  "missing_name",
  "missing_category",
  "missing_description",
  "missing_photos",
  "missing_hours",
  "missing_location",
];

interface POISearchParams {
  page?: number;
  limit?: number;
  mapId?: string;
  category?: string;
  status?: string;
  tagIds?: string[];
  accessibilityKeys?: string[];
  search?: string;
  completenessFilter?: CompletenessFilterValue;
  sortField?: SortField;
  sortDirection?: SortDirection;
  overrideFilter?: OverrideFilter;
  sponsorTier?: SponsorTierFilter;
}

const VALID_SORT_FIELDS: SortField[] = ["name", "status", "categoryName", "updatedAt"];
const VALID_OVERRIDE_FILTERS: OverrideFilter[] = ["hidden", "inherited", "modified", "map_specific"];
const VALID_SPONSOR_TIERS: SponsorTierFilter[] = ["any_sponsored", "not_sponsored"];

export const Route = createFileRoute("/$orgSlug/admin/pois")({
  validateSearch: (search: Record<string, unknown>): POISearchParams => ({
    page: typeof search.page === "number" ? search.page : undefined,
    limit: typeof search.limit === "number" ? search.limit : undefined,
    mapId: typeof search.mapId === "string" ? search.mapId : undefined,
    category: typeof search.category === "string" ? search.category : undefined,
    status: typeof search.status === "string" ? search.status : undefined,
    tagIds: typeof search.tagIds === "string"
      ? search.tagIds.split(",").filter(Boolean)
      : Array.isArray(search.tagIds)
        ? (search.tagIds as string[]).filter((t) => typeof t === "string")
        : undefined,
    accessibilityKeys: typeof search.accessibilityKeys === "string"
      ? search.accessibilityKeys.split(",").filter(Boolean)
      : Array.isArray(search.accessibilityKeys)
        ? (search.accessibilityKeys as string[]).filter((t) => typeof t === "string")
        : undefined,
    search: typeof search.search === "string" ? search.search : undefined,
    completenessFilter: VALID_COMPLETENESS_FILTERS.includes(search.completenessFilter as CompletenessFilterValue)
      ? (search.completenessFilter as CompletenessFilterValue)
      : undefined,
    sortField: VALID_SORT_FIELDS.includes(search.sortField as SortField) ? (search.sortField as SortField) : undefined,
    sortDirection: search.sortDirection === "asc" || search.sortDirection === "desc" ? search.sortDirection : undefined,
    overrideFilter: VALID_OVERRIDE_FILTERS.includes(search.overrideFilter as OverrideFilter) ? (search.overrideFilter as OverrideFilter) : undefined,
    sponsorTier: VALID_SPONSOR_TIERS.includes(search.sponsorTier as SponsorTierFilter) ? (search.sponsorTier as SponsorTierFilter) : undefined,
  }),
  // Component moved to $orgSlug.admin.pois.lazy.tsx for code splitting
});
